import { UtilsEnum } from '@/utils/UtilsEnum';

export const CENTRAL_REPROCESSAMENTO_TIPOS_ENUM = UtilsEnum.create({
  TODOS_OS_EVENTOS: { value: 'TODOS_OS_EVENTOS', description: 'Todos os eventos' },
  RUBRICAS: { value: 'RUBRICAS', description: 'Rubricas' },
  TRABALHADORES: { value: 'TRABALHADORES', description: 'Trabalhadores' },
});
